import { createDevicesConnectionModule } from '@pendo/services/MobilePairing';

export default {
    namespaced: true,
    ...createDevicesConnectionModule(),
};
